export { default as Img200 } from './processed/200/Alone_eBoard.jpg';
export { default as Img400 } from './processed/400/Alone_eBoard.jpg';
export { default as Imgthumb } from './processed/thumb/Alone_eBoard.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Alone_eBoard.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Alone_eBoard.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      111,
      49,
      45
    ],
    "_population": 18,
    "_hsl": [
      0.010101010101010102,
      0.423076923076923,
      0.3058823529411765
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      77,
      36,
      20
    ],
    "_population": 39,
    "_hsl": [
      0.046783625730994156,
      0.5876288659793815,
      0.19019607843137254
    ]
  },
  "Muted": {
    "_rgb": [
      156,
      92,
      84
    ],
    "_population": 1,
    "_hsl": [
      0.018518518518518514,
      0.30000000000000004,
      0.47058823529411764
    ]
  },
  "LightMuted": {
    "_rgb": [
      196,
      196,
      199
    ],
    "_population": 2566,
    "_hsl": [
      0.6666666666666666,
      0.026086956521739035,
      0.7745098039215687
    ]
  },
  "DarkMuted": {
    "_rgb": [
      81,
      71,
      59
    ],
    "_population": 2516,
    "_hsl": [
      0.09090909090909094,
      0.15714285714285708,
      0.27450980392156865
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Alone_eBoard.js